import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { WorkshopJob } from 'src/app/models/workshop-job';
import { WorkshopJobService } from 'src/app/shared/services/workshop-job.service';
import { MatButton } from '@angular/material/button';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatInput } from '@angular/material/input';
import { MatOption } from '@angular/material/core';
import { NgFor } from '@angular/common';
import { MatSelect } from '@angular/material/select';
import { MatFormField, MatLabel } from '@angular/material/form-field';

@Component({
    selector: 'app-edit-workshop-job',
    templateUrl: './edit-workshop-job.component.html',
    standalone: true,
    imports: [MatDialogTitle, ReactiveFormsModule, MatDialogContent, MatFormField, MatLabel, MatSelect, NgFor, MatOption, MatInput, CdkTextareaAutosize, MatDialogActions, MatButton, MatDialogClose]
})
export class EditWorkshopJobComponent {
  types = ['Repair', 'Service', 'Calibration'];
  form = new FormGroup({
    type: new FormControl(null, Validators.required),
    details: new FormControl(''),
    notes: new FormControl('')
  });

  constructor(
    private dialog: MatDialogRef<EditWorkshopJobComponent>,
    @Inject(MAT_DIALOG_DATA) public data: WorkshopJob<any>,
    private workshopJobService: WorkshopJobService
  ) {
    this.dialog.updateSize('700px');
    const { type, notes, details } = data;
    this.form.patchValue({
      type,
      details,
      notes
    });
    if (data.repairable_type === 'item') {
      this.types = [...this.types, 'Pre-hire', 'Off hire'];
    }
  }

  save() {
    this.workshopJobService
      .update(this.data.id, this.form.value)
      .subscribe(() => this.dialog.close({ update: true }));
  }
}
